import useSelectedContact from './useSelectedContact';

const useLastReadMessageIdOfSelectedContact = () => {
  const { selectedContact } = useSelectedContact();
  return selectedContact?.messages?.lastReadId || null;
};

export default useLastReadMessageIdOfSelectedContact;
